module.exports = __webpack_public_path__ + "static/media/sandra.7a584a4e.mp4";